var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9163 9.08366V3.41699C17.9163 2.16699 17.383 1.66699 16.058 1.66699H12.6913C11.3663 1.66699 10.833 2.16699 10.833 3.41699V9.08366C10.833 10.3337 11.3663 10.8337 12.6913 10.8337H16.058C17.383 10.8337 17.9163 10.3337 17.9163 9.08366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 10.917V16.5837C9.16634 17.8337 8.63301 18.3337 7.30801 18.3337H3.94134C2.61634 18.3337 2.08301 17.8337 2.08301 16.5837V10.917C2.08301 9.66699 2.61634 9.16699 3.94134 9.16699H7.30801C8.63301 9.16699 9.16634 9.66699 9.16634 10.917Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9163 16.5833V14.25C17.9163 13 17.383 12.5 16.058 12.5H12.6913C11.3663 12.5 10.833 13 10.833 14.25V16.5833C10.833 17.8333 11.3663 18.3333 12.6913 18.3333H16.058C17.383 18.3333 17.9163 17.8333 17.9163 16.5833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 5.75033V3.41699C9.16634 2.16699 8.63301 1.66699 7.30801 1.66699H3.94134C2.61634 1.66699 2.08301 2.16699 2.08301 3.41699V5.75033C2.08301 7.00033 2.61634 7.50033 3.94134 7.50033H7.30801C8.63301 7.50033 9.16634 7.00033 9.16634 5.75033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDashboardActive);
export default __webpack_public_path__ + "static/media/sidebar-dashboard-active.7a32e3e7f03c9343861ed23238def404.svg";
export { ForwardRef as ReactComponent };